import React, { useRef } from "react";
import { UncontrolledTooltip } from "reactstrap";
import { connect } from 'react-redux'

import { FaFile } from "react-icons/fa";
import { AiFillDelete } from "react-icons/ai";
import { BsFillImageFill } from "react-icons/bs";
import { requestError } from 'utils/requestHandler'
import Lang from 'Lang/General'

import "./index.scss";

const InputFile = ({
	onChange,
	fileValue,
	maxFileSize,
	fileName,
	acceptType,
	...props
}) => {
	let fileInputRef = useRef(null);

	let onDropFile = (event) => {
		let files = event.target.files;

		if (files && files.length > 0) {
			Object.keys(files).map(key => {
				let reader = new FileReader();
				reader.onload = function (event) {
					if (
						maxFileSize ? files?.[0]?.size > maxFileSize : files?.[0]?.size > 5000000) {
						return requestError(Lang['MAXIMUM_FILE_SIZE_5_MB'][props.data.languageReducer.userSettings.admin_panel_language])
					}
					if (event.target.result) {
						onChange({
							raw: event.target.result,
							url: event.target.result,
							filename: files[key].name
						});
					}
				};

				reader.readAsDataURL(files[key]);
			})
		}
	};

	return (
		<>
			<div className="custom_file-input">
				<div
					className={`custom_file-input-empty-div ${fileValue ? "d-none" : ''
						}`}
					onClick={() => fileInputRef.current.click()}>
					<input
						ref={fileInputRef}
						type={"file"}
						onChange={(event) => onDropFile(event)}
						style={{ display: "none" }}
						accept={acceptType || ".jpg,.jpeg,.png,.webp"}
					/>
					<BsFillImageFill className="custom_file-input-bg-svg" />
					<span className="custom_file-input-help-text">
						{
							Lang['UPLOAD_YOU_FILE_HERE'][props.data.languageReducer.userSettings.admin_panel_language]
						}
					</span>
				</div>
				{typeof fileValue === "string" && fileValue && (
					<div
						className={`custom_file-input-filled-div ${fileValue ? "" : "d-none"
							}`}>
						{
							(!acceptType || acceptType?.indexOf('pdf') < 0)
								? <img className="custom_file-input-img" src={fileValue} alt="" />
								: fileName && (
									<div
										className="bg-white shadow p-2" style={{ display: 'grid', placeItems: 'center', cursor: 'pointer' }}
										onClick={() => window.open(fileValue, '_blank')}
									>
										<FaFile style={{ width: 40, height: 40 }} />
										<span className="mt-2">{fileName}</span>
									</div>
								)
						}
						<AiFillDelete
							id={"RemoveFile"}
							className={"custom_file-input-remove-btn"}
							onClick={() => {
								onChange({
									raw: '',
									url: '',
									filename: ''
								});
								fileInputRef.current.value = "";
							}}
						/>
						<UncontrolledTooltip target={`RemoveFile`} placement="top">
							Click to remove the file here.
						</UncontrolledTooltip>
					</div>
				)}
			</div>
		</>
	);
};

const mapStateToProps = state => ({ data: state })
export default connect(mapStateToProps)(InputFile);
